/* eslint-disable @typescript-eslint/no-inferrable-types */
import { SmBaseEntity } from "src/modules/sm-base/shared/sm-base-entity.model";
import { Column, Entity, ManyToOne } from "typeorm";
import { ProductInformation } from "./productInformation.entity";
import { Additive } from "./additive.entity";

@Entity()
export class AdditiveProductInformation extends SmBaseEntity {
    @Column({default: ""})
    category: string = "";

    @Column({default: ""})
    eNumber: string = "";

    @Column({default: ""})
    additiveDescription: string = "";

    @Column({default: false})
    active: boolean = false;

    @Column({default: ""})
    displayLabel: string = "";

    @Column()
    wfId: string;

    @ManyToOne((_type) => ProductInformation, productInfo => productInfo.additives)
    product: ProductInformation;

    additive: Additive;
    label = "";
}